import { render, staticRenderFns } from "./CarEdit.vue?vue&type=template&id=f4b11564&"
import script from "./CarEdit.vue?vue&type=script&lang=js&"
export * from "./CarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports